module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_3.5cab92422a93f29abb0bf7a66d1ce1b8.png";